var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-col',{attrs:{"span":14}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"chart",attrs:{"id":"areaChart"}})]),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"chart",attrs:{"id":"channelChart"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }